import { buildHtml,ContentRoute, RouteSlotInput } from '@caritas/ui';

import { isDefined } from '../../utils/is-defined';

export function mapImpactNumbersBlock(
  input: BlockImpactNumbersFragment,
): RouteSlotInput<typeof ContentRoute, 'body', 'ImpactCommunication'> {
  return {
    key: 'ImpactCommunication',
    input: () => [
      {
        Title: input.injectedHeading
          ? buildHtml(input.injectedHeading)
          : undefined,
        items:
          input.items
            ?.filter(isDefined)
            .filter((item) => {
              return item.impactMedia && item.impactMedia.icon && item.impactMedia.metric && item.impactMedia.number;
            })
            .map((item) => {
              return {
                icon: item.impactMedia?.icon || 'give',
                description: item.impactMedia?.description || '',
                number: item.impactMedia?.number || '',
                metric: item.impactMedia?.metric,
                actuality: item.impactMedia?.actuality || '',
              };
            }) || [],
      },
      200,
    ],
  };
}
